define('app/views/travel_search_view',['app/setup', 'app/models/deal_card', 'app/collections/deal_collection'],
  function(takhfifan, dealCard, dealCollection) {
  takhfifan.travelSearchView = Backbone.View.extend({
    events: {
      'submit form': 'searchFormSubmit',
      'input #travelSearch': 'validateForm',
      'click .tkh-travel-search__results__cats a': 'filterSearchResult',
      'click #travelSearch' : 'suggestionCities',
      'click .optWrapper-tour-suggestion .options .opt' : 'setTourValue',
    },

    template: ( $('#deal-list-categorized-template').length > 0 ) ?
      _.template( $('#deal-list-categorized-template').html() ) : '',

    initialize: function () {
      var _this = this;
      this.initSearchCollection();
      this.initSearchForm();
      this.travelCategoryId = this.$el.data('parentId');
      this.subCats = _.clone(window.catsData);
      this.$mainPlaceHolder = $('.tkh-travel-search__main');
      this.$searchResultsPlaceHolder = $('.tkh-travel-search__results');
      this.$submitBtn = $('.travel-search__btn');
      this.$parent = this.$el.parent('.travel-header');
      this.initSearchFilterButtons();

      takhfifan.eventHub.on('travel:search', function (options) {
        this.applySearch(options);
      }, this);

      takhfifan.eventHub.on('route:reset', function(){
        this.applySearch();
      }, this);

      $('body').click(function(evt){
        if(evt.target.id !== "travelSearch"){
          _this.suggestionCitiesHide();
        }
      });
    },

    applySearch: function(options){
      if(!options){
        this.$searchBox.val('');
        this.$mainPlaceHolder.show();
        this.$searchResultsPlaceHolder.hide();
      }else{
        var category = options.category || this.travelCategoryId,
            location = options.location || "";

        this.$searchBox.val(location);
        if(location){
          this.$submitBtn.removeAttr('disabled');
        }
        this.submitSearch(category, location);
      }
    },

    initSearchForm: function(){
      this.$citySelector = this.$('#citySelect');
      this.$searchBox = this.$("#travelSearch");
      this.$residenceSelector = this.$('#residenceSelect');
    },

    initSearchCollection: function () {
      this.collection = new takhfifan.DealCardCollection;
      this.collection.type = "search";
      this.collection.nextPage = 1;
      this.collection.section = 'travel';
    },

    initSearchFilterButtons: function () {
      var _this = this;

      //remove search
      $(document).on('click','.tkh-travel-search__back', function(){
        takhfifan.travelSearchRoute.navigate("",{trigger: true, replace: false});
      });

      // toggle subcategories
      $(document).on('click','.tkh-travel-filters', function(){
        $(this).toggleClass('travel-filters--expand');
      });

      //filters
      $(document).on('click','.tkh-travel-search__filter', function(e){
        var $this = $(this),
            location = $this.data('location')?$this.data('location'):"";
        _this.$searchBox.val(location);
        // $(this).addClass('loading-view');

        if($this.prop('href').substring(0, 1) === "#"){
          e.preventDefault();
          var category = $this.data('category');

          var route = "travel_search/"+category+"/"+location;
          $this.prop('href', route);
          takhfifan.travelSearchRoute.navigate(route,{trigger: true, replace: false});
        }
      });

      $(document).on('mouseenter','.tkh-travel-search__filter', function(e){
        var $this = $(this),
            category = $this.data('category'),
            location = $this.data('location')?$this.data('location'):"",
            route = "#";

        if(category){
          route = "#travel_search/type/"+ category;
        }else if(location){
          route = "#travel_search/location/"+ decodeURIComponent(location);
        }

        $this.prop('href', route);
      });

      //filter results
      $(document).on('click','.tkh-travel-search__results__cats a', function(e){
        var $this = $(this);
        if($this.parent('li').hasClass('active')){
          _this.renderSearchResults();
        }else{
          _this.renderSearchResults([$this.data('categoryid')]);
        }
      });
    },

    trimString: function (s) {
      if(s) {
        if (String.prototype.trim) {
          return s.trim();
        } else {
          return s.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
      }
    },

    submitSearch: function (categories,location) {
      var _this = this;

      this.collection.address = location;
      this.collection.categories = categories;
      takhfifan.eventHub.trigger('travel:disable');
      _this.collection.nextPage = 1;
      var deals = [],
          availableCategories =[],
          countOfResults=0;

      this.collection.reset();
      this.collection.fetch({
        success: function (collection, response, options) {
          var searchTitle = "", isSearch = !!location;
          deals = collection.toJSON();
          availableCategories = _this.categorizeResults(deals, isSearch);
          countOfResults = deals.length;

          _this.$mainPlaceHolder.hide();
          $('.landingSection-part1, .landingSection-part2').css('display', 'none');
          _this.$searchResultsPlaceHolder.show();

          _this.$searchResultsPlaceHolder.html('');

          if(isSearch){
            searchTitle = "نتیجه جستجو در " + location;
          }else{
            //TODO: multiple category???
            searchTitle = "تخفیفان های " +(_this.subCats && _this.subCats[categories]? _this.subCats[categories].name: "هتل و سفر");
          }
          _this.currentSearchResultData = {
            deals: deals,
            count: countOfResults,
            title: searchTitle,
            isSearch: isSearch,
            cats: availableCategories,
            currentCat: categories,
            filters: []
          };
          _this.renderSearchResults();
          _this.goToResults();
        },
        error: function(){
          _this.$mainPlaceHolder.hide();
          _this.$searchResultsPlaceHolder.show();
          _this.$searchResultsPlaceHolder.html('');
          _this.currentSearchResultData = {
            deals: [],
            count: 0,
            cats: availableCategories,
            filters: []
          };
          _this.renderSearchResults();
        },
        complete: function () {
          takhfifan.eventHub.trigger('travel:enable');
          $('.loading-view').removeClass('loading-view');
        }
      });
    },

    searchFormSubmit: function(e){
      e.preventDefault();
      var location = this.trimString(this.$searchBox.val());
      if(location) {
        var route = "travel_search/location/" + encodeURIComponent(location);
        takhfifan.travelSearchRoute.navigate(route, {trigger: true, replace: false});
      }
    },

    getSelectedCategoryInfo: function () {
      var selectedCategories = $("#residenceSelect  option:selected"),
          selectedCatsData = [];

      _.each(selectedCategories,function(cat){
        selectedCatsData.push({
          name : $(cat).text(),
          id : $(cat).val()
        })
      });

      return selectedCatsData;
    },

    categorizeResults:function(deals, isSearch){
      var _this = this,
          availableCategories = [],
          categoryList = {};

      if(!isSearch){
        _.each(_this.subCats, function (catDetails, catId) {
          categoryList[catId] = {
            id      : catId,
            name    : catDetails.name,
            url     : catDetails.url,
            classes : catDetails.classes
          };
        })
      }else{
        _.each(deals,function(deal){
          availableCategories = _.union(availableCategories, deal.directCategories);
        });

        _.each(availableCategories, function (catId) {
          if(_this.subCats[catId]){
            if(!categoryList[catId]){
              categoryList[catId] = {
                id      : catId,
                name    : _this.subCats[catId].name,
                url     : _this.subCats[catId].url,
                classes : _this.subCats[catId].classes
              };
            }
          }
        });
      }

      return categoryList;
    },

    validateForm: function (e) {
      var $this = $(e.currentTarget);
      if($this.attr("id") === "travelSearch"){
        var searchTravel = this.$el.find('#travelSearch').val();
        var tourSuggestion = this.$el.find('.optWrapper-tour-suggestion');

        if (!searchTravel){
          tourSuggestion.css('display','block');
        } else{
          tourSuggestion.css('display','none');
          this.$submitBtn.removeAttr('disabled');
        }

        if($this.val() && this.trimString($this.val()).length > 1){
          this.$submitBtn.removeAttr('disabled');
        }else{
          this.$submitBtn.attr('disabled','disabled');
        }
      }
    },
    suggestionCities: function (e) {
      var searchTravel = this.$el.find('#travelSearch').val();
      var tourSuggestion = this.$el.find('.optWrapper-tour-suggestion');
      tourSuggestion.css('display','block');
    },
    suggestionCitiesHide: function () {
      var tourSuggestion = this.$el.find('.optWrapper-tour-suggestion');
      tourSuggestion.css('display','none');
    },
    setTourValue: function (e) {
      e.preventDefault();
      var cityName = $(e.currentTarget).children().text();
      var searchTravel = this.$el.find('#travelSearch');
      searchTravel.val(cityName);
      this.$submitBtn.removeAttr('disabled');
      this.suggestionCitiesHide()
    },

    goToResults: function () {
      var _this = this;
      $('html, body').animate({
        scrollTop: _this.$searchResultsPlaceHolder.offset().top - 150
      }, 500);
    },

    renderSearchResults: function (filters) {
      var searchData = _.clone(this.currentSearchResultData);
      if(filters){
        searchData.deals = _.filter(this.currentSearchResultData.deals, function(deal){
          return !!_.intersection(deal.directCategories, filters).length ;
        });

        searchData.count = searchData.deals.length;
        searchData.filters = filters;
      }
      this.$searchResultsPlaceHolder.html(this.template(searchData));
    }

  })
});

